/* eslint-disable import/no-anonymous-default-export */
export default {
  path: "/packaging",
  shortTitle: "Packaging",
  title: "Packaging and material responsibility",
  category: "Products and care",
  summary: "How product protection is balanced with packaging reduction without making unverified environmental claims.",
  updated: "26 October 2026",
  sections: [
    {
      heading: "Packing priorities",
      body: [
        "The first priority is that goods arrive clean, intact and separated from hazards. Prints need flat rigid support; glass and ceramics need impact spacing; metal finishes need scratch protection; textiles and natural fibres need a dry barrier; sealed food must remain separated from household products.",
      ],
    },
    {
      heading: "Material choices",
      body: [
        "Where compatible with safe fulfilment, packaging should be right-sized, avoid unnecessary layers and favour paper tissue, kraft board, paper cushioning and reusable cotton ties. The code and merchant information do not establish a certified recycled percentage, carbon-neutral shipment, compostability standard or take-back programme, so the site makes none of those claims.",
      ],
    },
    {
      heading: "Reuse and disposal",
      body: [
        "Customers may reuse clean boxes and paper cushioning. Disposal and recycling rules differ by local authority; remove tape, labels, food residue and mixed-material pieces where local instructions require it. Do not allow children or pets to play unsupervised with cords, film, staples, small packing pieces or damaged glass.",
      ],
    },
    {
      heading: "Damage and feedback",
      body: [
        "Keep all layers when reporting a damaged order because the arrangement helps identify failure. Send photographs of the exterior, label, cushioning and product. Suggestions about avoidable packaging can be emailed with the order number; material changes will be assessed against fragility, hygiene, moisture and cross-border handling requirements rather than promised automatically.",
      ],
    },
  ],
};
